import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  const {
    language
  } = useLanguage();
  const isGerman = language === 'de';
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-293" data-mp="1w12zwbu2jqmb">
      <SEO title="Impressum | CRM Kraft – Close CRM Agentur" description="Impressum von CRM Kraft LLC, vertreten durch Justus Kraft – Close CRM Agentur." canonical="https://close-crm-agentur-vergleich.de/impressum" noindex data-id="element-294" data-mp="1w4h47pmam9we" />
      <Navigation data-id="element-295" data-mp="2jr5qsom8yqjc" />
      <main className="pt-24 pb-16" data-id="element-296" data-mp="2jtrx6kxeizzz">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297" data-mp="2es2kz1yg0gab">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-298" data-mp="2eup0povhm23m">
            {isGerman ? 'Impressum' : 'Imprint'}
          </h1>

          <div className="prose prose-invert max-w-none" data-id="element-299" data-mp="2or1wcsaleq10">
            <section className="mb-8" data-id="element-300" data-mp="2osmpqel682xa">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-301" data-mp="1u6jmtewfcd4x">
                {isGerman ? 'Adresse' : 'Address'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-302" data-mp="1y8n0ma6kfttd">
                CRM Kraft LLC
                <br data-id="element-303" data-mp="2366m9v5lf8vc" />
                {isGerman ? 'Vertreten durch: Justus Kraft' : 'Represented by: Justus Kraft'}
                <br data-id="element-304" data-mp="2d5464ks2qe80" />
                7901 4th St. N, Ste. 300
                <br data-id="element-305" data-mp="2d4mbttoz2a2q" />
                St. Petersburg, FL 33702
                <br data-id="element-306" data-mp="2h5xwdkszo542" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-307" data-mp="2lx66kj257uia">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-308" data-mp="2ly7rdf8ynvd7">
                {isGerman ? 'Kontakt' : 'Contact'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-309" data-mp="2vvvpmf5rzl04">
                {isGerman ? 'Telefon' : 'Phone'}: +491745444423
                <br data-id="element-310" data-mp="30vruegmarggq" />
                {isGerman ? 'E-Mail' : 'Email'}: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-311" data-mp="2b6ug5zf9lm8g">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-312" data-mp="267qavjvgo8ne">
                {isGerman ? 'EU-Streitschlichtung' : 'EU Dispute Resolution'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-313" data-mp="2kyh0cl9kyvnc">
                {isGerman ? 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: ' : 'The European Commission provides a platform for online dispute resolution (ODR): '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-314" data-mp="2p02cu5i7d7x0">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-315" data-mp="14i4d0hm7k3fn" />
                {isGerman ? 'Unsere E-Mail-Adresse finden Sie oben im Impressum.' : 'You can find our email address above in this imprint.'}
              </p>
            </section>

            <section data-id="element-316" data-mp="3l3j54311z6p5">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-317" data-mp="3l41bvtlcd3bb">
                {isGerman ? 'Verbraucherstreitbeilegung/Universalschlichtungsstelle' : 'Consumer Dispute Resolution / Universal Arbitration Board'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-318" data-mp="2xeqemm379r1x">
                {isGerman ? 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.' : 'We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.'}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-319" data-mp="lnmka9rj3ucn" />
    </div>;
}